module.exports = __webpack_public_path__ + "dist/media/caret.3a37211c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caret.svg
// module id = 359
// module chunks = 0